import url from 'modules/utils/uri';
import sessionStorage from 'modules/session-storage';

const CLIENT_CHAT_PRELOAD = 'CLIENT_CHAT_PRELOAD';

function removeFrame(frame) {

    document.body.removeChild(frame);

}
export function create(args) {
    var chatPreloaded = sessionStorage.getItem(CLIENT_CHAT_PRELOAD);
    if (chatPreloaded !== 'true') {
        const frame = document.createElement('iframe');
        frame.style.display = 'none';
        frame.src = "https://" + args + "/chat/#/0";
        document.body.appendChild(frame);

        window.addEventListener('message', function (event) {
            if (url.parse(event.origin).hostname === args) {
                if(typeof (event.data) === 'string'){
                    let parsed = JSON.parse(event.data);
                    if (parsed['message_type'] === CLIENT_CHAT_PRELOAD) {
                        sessionStorage.setItem(CLIENT_CHAT_PRELOAD, 'true');
                        removeFrame(frame);
                    }
                }


            }
        })
    }


}